import gql from "graphql-tag";

export const getModulesByPaginationQuery = gql`
  query getModulesByPaginationQuery(
    $searchtext: String
    $sortedBy: [ModuleListSortedByType]
    $limit: Int
    $offset: Int
  ) {
    modulesByPaginationQuery(
      searchtext: $searchtext
      sortedBy: $sortedBy
      limit: $limit
      offset: $offset
    ) {
      modules {
        id
        moduleName
        moduleDisplayName
      }
      rowCount
    }
  }
`;

export const getModuleByIdQuery = gql`
  query getModuleByIdQuery($id: Int) {
    moduleByIdQuery(id: $id) {
      id
      moduleName
      moduleDisplayName
    }
  }
`;

export const modulesFunctionalityByModuleIdQuery = gql`
query modulesFunctionalityByModuleId($moduleId: Int) {
    modulesFunctionalityByModuleId(moduleId: $moduleId) {
      id
      functionalityName
      functionalityDisplayName
      functionalityPortal
      permissions {
        id
        permissionName
        permissionDisplayName
        permissionCode
        moduleFunctionalityName
        description
      }
    }
  }
`;

export const updatePermissionOrderMutation = gql`
  mutation updatePermissionOrder(
    $permissions: [UpdatePermissionOrderInputType]
  ) {
    updatePermissionOrder(permissions: $permissions) {
      id
    }
  }
`;

export const updateModuleFunctionalityOrderMutation = gql`
  mutation updateModuleFunctionalityOrder(
    $moduleFunctionalities: [UpdateModuleFunctionalityOrderInputType]
  ) {
    updateModuleFunctionalityOrder(moduleFunctionalities: $moduleFunctionalities) {
      id
    }
  }
`;


export const updateModuleOrderMutation = gql`
  mutation updateModuleOrder(
    $modules: [UpdateModuleOrderInputType]
  ) {
    updateModuleOrder(modules: $modules) {
      id
    }
  }
`;



export const addModuleOrderMutation = gql`
  mutation addModuleOrder(
    $modules: UpdateModuleOrderInputType
  ) {
    addModuleOrder(modules: $modules) {
      id
    }
  }
`;


export const addModuleFunctionalityOrderMutation = gql`
  mutation addFunctionality(
    $functionality: AddFunctionlityInputType
  ) {
    addFunctionality(functionality: $functionality) {
      id
    }
  }
`;